<template>
  <p
    class="blok-title"
    v-editable="blok"
    :class="styleClasses"
    :style="styleCode"
  >
    {{ blok.text }}
  </p>
</template>

<script>
export default {
  name: 'blok-title',
  props: ['blok'],
  computed: {
    styleClasses() {
      return this.blok.style || ''
    },
    styleCode() {
      return this.blok.style_code || ''
    },
  },
}
</script>
